import { Component, OnInit } from '@angular/core';
import {byNumeric} from 'iso-country-codes';
import {GiftCard, Referral} from "../../../dto/order";
import {PrevNextModel} from "../../../models/prev-next-model";
import {ContentRowField} from "../../../shared/content-row/content-row.component";
import {DateFormats, toCardExpireDateString, toDateString, toDateTimeString} from "../../../providers/app-date-adapter";
import {Customer} from "../../../dto/customer";
import {Card} from "../../../dto/card";
import {PrevNextIdModel} from "../../../models/prev-next-id-model";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {DatePipe, Location} from "@angular/common";
import {ReferralsService} from "../../services/referrals.service";
import {OrdersBadgeService} from "../../services/orders-badge.service";
import {MatDialog} from "@angular/material/dialog";
import {RoleService} from "../../../services/role.service";
import {EventLogService} from "../../../services/crud/event-log.service";
import {ToastService} from "angular-toastify";
import {CustomersService} from "../../services/customers.service";
import {CardsService} from "../../services/cards.service";
import {Observable} from "rxjs";
import {GiftCardsService} from "../../../services/gift-cards.service";
import {GpsCardStatusHelper} from "../../../dto/gps-card-status";
import {CardReorderReason} from "../../../dto/card-reorder-reason";
import {ReorderDelayReason} from "../../../dto/reorder-delay-reason";
import {CardUsageStatus} from "../../../dto/ident-status";

@Component({
  selector: 'app-gift-card-details',
  templateUrl: './gift-card-details.component.html',
  styleUrls: ['./gift-card-details.component.css']
})
export class GiftCardDetailsComponent  implements OnInit {

  giftCard: GiftCard;
  giftCardId: number;
  prevNext: PrevNextModel;
  isLoadingGiftCard: boolean;





  fields = [
    { header: 'Brand', link: row => '../../brands/' + row.brand.id, cell: row => `${row.brand.name}` } as ContentRowField<GiftCard>,
    { header: 'Customer', link: row => '../../../customers-overview/' + row.customerId, cell: row => `${row.customer.firstName} ${row.customer.lastName}` } as ContentRowField<GiftCard>,
    { header: 'Created at', cell: row => `${ this.datePipe.transform( row.creationDate, DateFormats.DisplayDateTime ) }` } as ContentRowField<GiftCard>,
    { header: 'Valid until', cell: row => row.expirationDate ? `${ this.datePipe.transform( row.expirationDate, DateFormats.DisplayDate ) }` : '-' } as ContentRowField<GiftCard>,
    { header: 'Face Value', cell: row => {
        return `${row.faceValue} ${row.faceCurrency}`;
      }
    } as ContentRowField<GiftCard>,
    { header: 'Purchase Price', cell: (row: GiftCard) => {

        return `${row.purchasePrice} EUR`;

      } } as ContentRowField<GiftCard>,

    { header: 'Amount Paid', cell: (row: GiftCard) => {

        return `${row.amountPaid} EUR`;

      } } as ContentRowField<GiftCard>,
    { header: 'Internal Cost', cell: row => {
        return `${row.costAmount} ${row.costCurrency}`;
      }
    } as ContentRowField<GiftCard>,
    { header: 'Current Balance', cell: row => {
        return `unknown / TODO`;
      }
    } as ContentRowField<GiftCard>,
    { header: 'Is Paid', cell: row => {
        return row.isPaid ? 'Yes':'No';
      }
    } as ContentRowField<GiftCard>,
    { header: 'Payment Txn', cell: row => {
        return row.paymentTxnId;
      }
    } as ContentRowField<GiftCard>,
    { header: 'Payment Ac', cell: row => {
        return row.paymentTxnActionCode;
      }
    } as ContentRowField<GiftCard>,
    { header: 'Countries', cell: row => {
        return row.brand.countriesServed;
      }
    } as ContentRowField<GiftCard>,

  ];

  fieldsCustomer= [

    { header: 'Link', icon: (row) => 'visibility', link: (row) => '../../../customers-overview/' + (row.id || ''), cell: (row) => `Customer` } as ContentRowField<Customer>,
    { header: 'Name', cell: (row) => `${row.title} ${row.firstName} ${row.lastName}` } as ContentRowField<Customer>,
    { header: 'DOB', cell: (row) => `${toDateString(row.dob) || ''}` } as ContentRowField<Customer>,
    { header: 'Address', cellFlag: (row) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2, cell: (row) => `${row.address || ''}, ${row.zipCode || ''} ${row.city || ''}, ${row.countryName || ''}` } as ContentRowField<Customer>,
    { header: 'Email', cell: (row) => `${row.email || ''}` } as ContentRowField<Customer>,
    { header: 'Mobile', cell: (row) => `+${row.phone || ''}` } as ContentRowField<Customer>,


    {header: 'IP Address'
      , cell: (row: Customer) => {
        const ret = row.ipAddress || '';
        return ret;

      }},

  ]  as ContentRowField<Customer>[];

  cardFields = [
    { header: 'Card name', cell: (row: Card) => `${row.cardName || ''}` },
    { header: 'Status', cell: (row: Card) => `${row.statusName || ''}` },
    { header: 'Exp date', cell: (row: Card) => `${toCardExpireDateString(row.expireDate) || ''}` },
    { header: 'Token', cell: (row: Card) => `${row.token}` },
    { header: 'Product', cell: (row: Card) => `${row.productName}` },
    { header: 'Creation Date', cell: (row: Card) => `${toDateTimeString(row.creationDate) || ''}` },
    { header: 'Activation date', cell: (row: Card) => `${toDateTimeString(row.activationDate) || ''}` },
    { header: 'Order date', cell: (row: Card) => `${toDateString(row.orderDate) || ''}` },
    // <a route_to_page search_string information_to_display
    { header: 'PAN'      , cell: (row: Card) => `${row.maskedPAN || '(unknown)' }` },
    { header: 'Card Type', cell: (row: Card) => `${row.cardTypeName || '(unknown)'}`},
  ] as ContentRowField<Card>[];





  prevNextIds: PrevNextIdModel;

  loadingPrevNext = false;
  loadingPrev = false;
  loadingNext = false;
  public customer: Customer|null;
  public isLoadingCustomer: boolean;
  public customerCards: Card[] = [];
  public isLoadingCards: boolean;

  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private giftCardsService: GiftCardsService,

    public roleService: RoleService,
    private logService: EventLogService,
    private datePipe: DatePipe,
    private _toastService: ToastService,
    private customersService: CustomersService,
    private cardsService: CardsService,


  ) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      const idParam = params['id'];
      this.giftCardId = idParam;
      this.clearData();
      this.initComponent(idParam);

    });

  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }


  initComponent(giftCardId: number) {

    this.getGiftCardData(giftCardId);

  }
  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  returnBack() {
    this.location.back();
  }


  reorderDelayReason = ReorderDelayReason;
  gpsCardStatusHelper = GpsCardStatusHelper;
  cardUsageStatus = CardUsageStatus;


  getCustomerCards(customerId: number): Observable<Card[]> {
    return this.cardsService.getForCustomer(customerId);
  }

  getCustomerData() {
    if ( !this.giftCard.customerId ) {
      return;
    }

    this.isLoadingCustomer = true;

    this.customersService.get(this.giftCard.customerId)
      .subscribe(result => {
        this.customer = result;

        this.isLoadingCards = true;
        this.getCustomerCards(this.customer.id).subscribe(data => {
          this.customerCards = data;
          this.isLoadingCards = false;
        });
        this.isLoadingCustomer = false;
      });
  }

  getGiftCardData(giftCardId: number) {
    this.isLoadingGiftCard = true;
    this.giftCardsService.get(giftCardId)
      .subscribe(result => {
        this.giftCard = result;
        this.isLoadingGiftCard = false;

        this.getCustomerData();

      }, error => {
        this._toastService.error('Unable to load gift card: ' + error.message);
      });
  }


  clearData() {
    this.prevNext = null;
  }



}
